import React, { useCallback } from "react";
import { useMappedState } from "redux-react-hook";
import { Link } from "react-router-dom";
import {
  Toolbar,
  ToolbarGroup,
  ToolbarItem,
  Button,
  Level,
  LevelItem,
} from "@patternfly/react-core";
import FilterInput from "../general/FilterInput";
import { isAdmin, isProductManager } from "../../utils/userUtil";

export default (props) => {
  const mapState = useCallback(
    (state) => ({
      currentUser: state.userState.currentUser,
    }),
    []
  );

  const { currentUser } = useMappedState(mapState);

  const levelStyle = {
    backgroundColor: "#fff",
    paddingTop: "1rem",
    paddingBottom: "1rem",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    borderBottom: "1px solid #ccc",
  };

  function renderCreateButton() {
    if (isAdmin(currentUser.roles) || isProductManager(currentUser.roles)) {
      return (
        <ToolbarItem>
          <Link to="/product/group/create">
            <Button variant="primary" style={{ marginLeft: "1rem" }}>
              Create Group
            </Button>
          </Link>
        </ToolbarItem>
      );
    }
  }

  return (
    <Level hasGutter style={levelStyle}>
      <LevelItem>
        <Toolbar className="view-toolbar pf-u-px-md pf-u-py-md">
          <ToolbarGroup>
            <ToolbarItem className="pf-u-mr-md">
              <FilterInput
                itemName={"Product Group"}
                onChange={props.handleFilterValueChange}
              />
            </ToolbarItem>
            {renderCreateButton()}
          </ToolbarGroup>
        </Toolbar>
      </LevelItem>
    </Level>
  );
};
